import { useMemo } from 'react';

import { AmenityTranslations } from '@app/helpers/accommodation-tile-amenities.helpers';
import { filterAmenities, sortAmenities } from '@app/helpers/sort-filter-amenities';
import { InternalAmenityGroupEnum } from '@app/models/api/api-types';
import { AmenityGroupModel } from '@app/models/elastic-search';

import { AccommodationTileAmenitiesProps } from './accommodation-tile-amenities.props';
import { AccommodationTileAmenitiesDynamic } from './accommodation-tile-amenities-dynamic';
import { AccommodationTileAmenitiesStatic } from './accommodation-tile-amenities-static';

export const AccommodationTileAmenities = ({
    amenities,
    accommodationId,
    t,
    maxVisible,
    ...rest
}: AccommodationTileAmenitiesProps) => {
    const sortedAmenities: AmenityGroupModel[] | undefined = useMemo(
        () =>
            amenities
                ? sortAmenities(filterAmenities(amenities as unknown as AmenityGroupModel[]))
                : undefined,
        [amenities],
    );

    if (!sortedAmenities) {
        return;
    }

    const getAmenityLabel = (amenity: AmenityGroupModel): string => {
        if (amenity.type === InternalAmenityGroupEnum.Parking && amenity.free === true) {
            return t('amenities.freeParking');
        }
        return amenity.label;
    };

    const translations = t('otherItems', {
        returnObjects: true,
    }) as AmenityTranslations;

    if (maxVisible) {
        return (
            <AccommodationTileAmenitiesStatic
                sortedAmenities={sortedAmenities}
                maxVisible={maxVisible}
                getAmenityLabel={getAmenityLabel}
                translations={translations}
                {...rest}
            />
        );
    }

    return (
        <AccommodationTileAmenitiesDynamic
            sortedAmenities={sortedAmenities}
            getAmenityLabel={getAmenityLabel}
            {...rest}
        />
    );
};
